import script from "./MapLayerSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./MapLayerSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./MapLayerSwitcher.vue?vue&type=style&index=0&id=c5eff3de&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5eff3de"]])

export default __exports__